"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _releaseUtils = _interopRequireDefault(require("../release/releaseUtils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len, no-console */
var _default = function _default(execSync, prompt, currentVersion) {
  var exec = function exec(command) {
    return execSync(command, {
      stdio: 'inherit'
    });
  }; // Have the user select if the branch will be a release branch or hotifx branch.


  var releaseOrHotfix = prompt("\n  Is this a:\n    1) Release\n    2) Hotfix\n    3) Minor/isolated Release\n  Type 1, 2, or 3!\n  ");

  if (!['1', '2', '3'].includes(releaseOrHotfix)) {
    console.error('You need to select 1 for release, 2 for hotfix, or 3 for a minor release. Try again!');
    process.exit(1);
  }

  var branchPrefix = _releaseUtils.default.branchMap[releaseOrHotfix];

  if (releaseOrHotfix === _releaseUtils.default.branchMap.release) {
    // 1a) Checkout develop
    exec('git checkout develop');
  } else {
    // 1b) Checkout master
    exec('git checkout master');
  } // 2) Pull the latest


  exec('git pull');

  var suggestedNextVersion = _releaseUtils.default.calculateNextReleaseSemver(releaseOrHotfix, currentVersion);

  var nextVersion = prompt("What should the next version be (current version is ".concat(currentVersion, ")?\n    Suggested version is ").concat(suggestedNextVersion, ".\n    Leave blank and press enter for suggested version or enter a new version number: \n")); // Replace next version with suggested if no version is entered

  var re = /^\d+\.\d+\.\d+$/;

  if (!nextVersion) {
    nextVersion = suggestedNextVersion;
  } else if (!re.test(nextVersion)) {
    console.error('Please enter a valid semver value');
    process.exit(1);
  } // 3) Create a new release--{nextVersion} branch


  exec("git checkout -b ".concat(branchPrefix, "--").concat(nextVersion)); // 4) Increment the package version in package.json and the appropriate lockfile
  // NOTE: we use `--no-git-tag-version` to tell npm not to:
  //   a) create a version commit (we'll do that manually in the next step)
  //   b) create a version tag

  exec("npm --no-git-tag-version version ".concat(nextVersion)); // 5) Add package.json

  exec('git add package.json'); // 6) Try adding either package-lock.json or npm-shrinkwrap.json. Don't fail if one doesn't exist
  //    (one or the other should exist within any of the repos that use web-utils).

  try {
    exec('git add package-lock.json');
    console.log('Added package-lock.json');
  } catch (e) {
    console.log('Could not add package-lock.json - most likely npm-shrinkwrap.json exists instead.');
  }

  try {
    exec('git add npm-shrinkwrap.json');
    console.log('Added npm-shrinkwrap.json');
  } catch (e) {
    console.log('Could not add npm-shrinkwrap.json - most likely package-lock.json exists instead.');
  } // 7) Create a new commit with the version bump message


  exec("git commit -nm \"version bump ".concat(nextVersion, "\"")); // 8) Push up to github and track.

  exec("git push -u origin ".concat(branchPrefix, "--").concat(nextVersion));
  console.log("Yaaaas: ".concat(branchPrefix, " branch has been successfully \u2702\uFE0F"));
};

exports.default = _default;